import { FetchContext } from '../fetch-context';
import { Question } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const getQuestionnaireQuestions: (
  fetchContext: FetchContext,
  winnerId: number,
  accessToken?: string,
) => Promise<Question[]> = (fetchContext, winnerId, accessToken) => fetch(`${fetchContext.baseUrl}/api/winners/${winnerId}/questions`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<Question[]>(fetchContext.errorStore, response, 'get questionnaire questions'));
